import React, { useContext, useEffect, useState} from "react";
import { Link, useNavigate } from "react-router-dom";
import noteContext from "../context/notes/noteContext";
import Modal from "./Modal";
import NotesItem from "./NotesItem";

const NotesTable = (props) => {
  const context = useContext(noteContext);
  const [captcha, setCaptcha] = useState(Math.ceil(Math.random()*100000))
  const { notes, updateNotes, deleteNote } = context;
  let count = 0;
  let navigate = useNavigate();
  document.title = props.title;

  useEffect(() => {
    if (localStorage.getItem("auth-token")) {
      updateNotes();
    } else {
      navigate("/auth/login");
    }
  }, []);

  const updateCaptcha = ()=>{
    setCaptcha(Math.ceil(Math.random()*100000))
  }

  const handleEraseAll = () => {
    notes.map((element) => {
        deleteNote(element._id);
      });
      props.showAlert("success", "Success", "All Notes Deleted Successfully");
  };

  return (
    <>
      <div className="d-flex flex-column mb-5">
        <h2
          className={`text-center pt-3 ${
            props.theme === "dark" ? "text-light" : ""
          } `}
        >
          Your Notes
        </h2>
        <div className="d-flex justify-content-end">
          <Link to="/addNote">
            <button className="btn btn-primary m-2 justify-items-center">
              Add New Note <i className="uil uil-file-plus-alt"></i>
            </button>
          </Link>
          <button
            className={`btn btn-danger mx-2 my-2 justify-items-center ${
              notes.length !== 0 ? "" : "disabled"
            }`}
            type="button"
            data-bs-toggle="modal"
            data-bs-target="#EraseAllNotesModal"
            onClick={updateCaptcha}
          >
            Erase All <i className="uil uil-trash-alt"></i>
          </button>
          <Modal showAlert={props.showAlert} theme={props.theme} captcha={captcha} modalId="EraseAllNotesModal" requiredFunc={handleEraseAll} message="Are you really wants to Delete your all Notes?" title="Delete Confirmation"/>
        </div>
        <table
          className={`table mt-2 mb-4 border border-2 rounded border-dark text-center ${
            props.theme === "dark" ? "text-light" : ""
          }`}
        >
          <thead>
            <tr>
              <th scope="col" className="border">
                <b>#</b>
              </th>
              <th scope="col" className="border">
                TITLE
              </th>
              <th scope="col" className="border">
                DESCRIPTION
              </th>
              <th scope="col" className="border">
                TAG
              </th>
              <th scope="col" className="border">
                ACTION
              </th>
            </tr>
          </thead>
          <tbody className="table-group-divider border">
            {notes.length !== 0 ? (
              notes.map((element) => {
                count++;
                return (
                  <NotesItem
                    key={element._id}
                    count={count}
                    title={element.title}
                    description={element.description}
                    tag={element.tag}
                    noteId={element._id}
                    showAlert={props.showAlert}
                  />
                );
              })
            ) : (
              <tr>
                <td colSpan={5}>No Notes Available to Show</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default NotesTable;
